import { render } from "./login-button.vue?vue&type=template&id=98b83d3a&ts=true"
import script from "./login-button.vue?vue&type=script&lang=ts"
export * from "./login-button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__